export default __webpack_public_path__ + "static/media/remote-meeting-logo-white.1a1f4183.png";